import { locales } from '@/constants/supportedLocales';
import { mycaCardTypes, lineOfBusinessTypes } from '@/constants/productMapping';

export const isActiveAccount = (account) => {
  return account?.active;
};

export const isActiveCenturionAccount = (account) => {
  return (
    account?.active && account?.product?.type?.includes(mycaCardTypes.centurion)
  );
};

// This function will return the account token of the first active Centurion account or the first active account
export const getCenturionOrActiveToken = (wallet) => {
  const centurionAccountToken = wallet?.find(
    isActiveCenturionAccount
  )?.accountToken;
  const activeAccountToken = wallet?.find(isActiveAccount)?.accountToken;
  return centurionAccountToken || activeAccountToken;
};

/*
  This function checks if an account is eligible for Centurion Lounge guest benefits.
  Eligibility criteria:
  - Active account.
  - US Consumer Platinum or US Business Platinum Card (Intl Dollar and Corporate cards get 2 free guests).
*/
export const isGuestBenefitEligibleAccount = (account) => {
  return (
    account?.active &&
    account?.product?.type?.includes(mycaCardTypes.platinum) &&
    account?.lineOfBusinessTypeName !== lineOfBusinessTypes.Corporate &&
    account?.homeCountryLocale?.toLowerCase() ===
      locales.UnitedStates.toLowerCase()
  );
};
